import { PortalDropdown, usePortalDropdown } from '../portalDropdown';
import { HiChevronDown } from 'react-icons/hi';

export interface FilterOption<TValue extends string | number> {
  value?: TValue;
  label: string;
}

export interface FilterDropdownProps<TValue extends string | number> {
  title: string;
  value?: TValue;
  options: Array<FilterOption<TValue>>;
  onChange: (value?: TValue) => void;
  className?: string;
}

const FilterDropdownItem = <TValue extends string | number>({
  option,
  isSelected,
  onSelect,
}: {
  option: FilterOption<TValue>;
  isSelected: boolean;
  onSelect: (value?: TValue) => void;
}) => {
  const { close } = usePortalDropdown();

  return (
    <button
      type="button"
      className={`flex w-full items-center rounded-lg px-3 py-2 text-left text-sm hover:bg-gray-100 ${
        isSelected ? 'bg-gray-100 font-medium text-gray-900' : 'text-gray-700'
      }`}
      onClick={() => {
        onSelect(option.value);
        close();
      }}
    >
      {option.label}
    </button>
  );
};

export const FilterDropdown = <TValue extends string | number>(
  props: FilterDropdownProps<TValue>
) => {
  const selected = props.options.find((o) => o.value === props.value);
  const selectedLabel = selected?.label ?? 'Все';

  return (
    <PortalDropdown
      dismissOnClick={false}
      className="w-64 p-2"
      trigger={
        <button
          type="button"
          className={`flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm hover:bg-gray-50 ${props.className || ''}`}
        >
          <span className="text-gray-500">{props.title}:</span>
          <span className="truncate">{selectedLabel}</span>
          <HiChevronDown className="h-4 w-4 shrink-0 text-gray-500" />
        </button>
      }
    >
      <div className="flex flex-col gap-1">
        {props.options.map((option) => (
          <FilterDropdownItem
            key={`${option.value ?? 'all'}`}
            option={option}
            isSelected={option.value === props.value}
            onSelect={props.onChange}
          />
        ))}
      </div>
    </PortalDropdown>
  );
};

